import helvetica from './helveticaGlyphWidths.json';

export function getTextWidth({text,fontSize}){

  if( text === null || text === undefined ){ throw Error("Missing text arg.") }
  if( !fontSize ){ throw Error("Missing font size.") }

  return Array.from(text).reduce((width,letter) => {
    if( !(letter in helvetica) ){
      throw Error("Cannot measure character '"+text+"'. Text will not be positioned correctly.");
    }
    return width + Number(helvetica[letter]) * fontSize;
  },0)
}


export function getTextBoundingBox({text,style}){

  /*
    
    First, we just get the text itself.
    Then, we determine BOUNDS/RECT by its angle.
    Finally, we get POSITION of the item
    But the "bounding rect" and where to start/draw is going to differ based on angle of the text. 

    For example, the bounding box of text rotated upwards,
    the STARTING point is bottom-left

    Drawing TEXT for svg, you start it 
    at the X,Y location

  */


}
